<!-- Begin WebApp tabs -->
@if (initialized) {
  <div soho-tabs
    class="is-personalizable"
    headerTabs="true"
    [disableAutoUpdatedCall]="false"
    (afterActivated)="onTabActivated($event)">
    <div soho-tab-list-container id="header-tabs">
      @if (displayDataGrid) {
        <ul soho-tab-list>
          <li soho-tab [disabled]="disableReportTab">
            <a soho-tab-title tabId="{{TAB_ID_ALLREPORTS}}" data-automation-id="lm-reports-catalog-allreports-tab">{{catalogTabTitle}}</a>
          </li>
          @if (printFilesEnabled) {
            <li soho-tab>
              <a soho-tab-title tabId="{{TAB_ID_PRINTFILES}}" data-automation-id="lm-reports-catalog-printfiles-tab">{{printFilesTabTitle}}</a>
            </li>
          }
        </ul>
      }
    </div>
  </div>
  <div soho-tab-panel-container
    soho-busyindicator
    [blockUI]="true"
    displayDelay="100"
    class="lm-reports-catalog-wrapper"
    id="lm-reports-catalog-wrapper">
    @if (displayDataGrid) {
      <div soho-tab-panel
        tabId="{{TAB_ID_ALLREPORTS}}"
        id="{{TAB_ID_ALLREPORTS}}"
        class="scrollable">
        <lm-reports-list
          [reportsArray]="reportsArray$ | async"
          [categoriesByModule]="categoriesByModule$ | async"
          reportListId="all-list"
          (reportListEvent)="onReportListEvent($event)"
        ></lm-reports-list>
      </div>
    }
    @if (displayDataGrid && printFilesEnabled) {
      <div soho-tab-panel
        tabId="{{TAB_ID_PRINTFILES}}"
        id="{{TAB_ID_PRINTFILES}}"
        class="scrollable">
        <div class="tab-list-container">
          <div class="columns nine">
            <div [ngStyle]="{'overflow': 'hidden'}">
              @if (!doRetrievePrintFilesSpec && printFilesListUrlInfo) {
                <lm-list #LMPrintCompletedListComponent
                  [listUrlInfo]="printFilesListUrlInfo"
                  [listSpec]="printFilesListSpec"
                  [hasDependentData]="false"
                  [listInPagePaneTab]="true"
                  [pageHasContextForm]="false"
                  [pageHasTabs]="true"
                  (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                ></lm-list>
              }
            </div>
          </div>
          <div class="card columns three border-less lm-report-catalog-widget-container">
            <div class="lm-report-catalog-widget">
              <div class="card columns twelve has-pager">
                <div class="card-header">
                  <h2
                    class="widget-title"
                    attr.id="in-process_widget_title"
                    attr.data-automation-id="lm-report-catalog-in-process-widget-title"
                    ><lm-widget-title [title]="'InProgress' | translate"></lm-widget-title></h2>
                  </div>
                  <div class="card-content" [ngStyle]="{'overflow': 'hidden'}">
                    @if (!doRetrievePrintFilesSpec && printQueueListUrlInfo) {
                      <lm-list #LMPrintQueueListComponent
                        [listUrlInfo]="printQueueListUrlInfo"
                        [listSpec]="printQueueListSpec"
                        [hasDependentData]="false"
                        [listInPagePaneTab]="true"
                        [pageHasContextForm]="false"
                        [pageHasTabs]="true"
                        (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                      ></lm-list>
                    }
                  </div>
                </div>
              </div>
              @if (showScheduledWidget) {
                <div class="lm-report-catalog-widget">
                  <div class="card columns twelve has-pager">
                    <div class="card-header">
                      <h2
                        class="widget-title"
                        attr.id="scheduled_widget_title"
                        attr.data-automation-id="lm-report-catalog-scheduled-widget-title"
                        ><lm-widget-title [title]="'Scheduled' | translate"></lm-widget-title></h2>
                      </div>
                      <div class="card-content" [ngStyle]="{'overflow': 'hidden'}">
                        @if (!doRetrievePrintFilesSpec && printScheduleListUrlInfo) {
                          <lm-list #LMPrintScheduledListComponent
                            [listUrlInfo]="printScheduleListUrlInfo"
                            [listSpec]="printScheuduleListSpec"
                            [hasDependentData]="false"
                            [listInPagePaneTab]="true"
                            [pageHasContextForm]="false"
                            [pageHasTabs]="true"
                            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                          ></lm-list>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
      <div #modalPlaceholder id="modalPlaceholder"></div>
    }